// Tab indices
export const TAB_INDICES = {
    REQUEST_DETAILS: 0,
    PRODUCTS: 1,
    SUPPORT: 2,
    PLAN_STATUS: 2,
    SUPPORT_DETAILS: 3
};

// View mode tab indices
export const VIEW_TAB_INDICES = {
    REQUEST_DETAILS: 0,
    PRODUCTS: 1,
    PLAN_STATUS: 2,
    SUPPORT_DETAILS: 3
};

// Tab labels
export const TAB_LABELS = {
    REQUEST_DETAILS: 'Request Details',
    PRODUCTS: 'Products',
    SUPPORT: 'Support',
    PLAN_STATUS: 'Plan Status',
    SUPPORT_DETAILS: 'Support Details'
};

// UI Text constants
export const UI_TEXT = {
    PAGE_TITLE: 'Exit Plans & Exemption Requests',
    CURRENT_PLANS: 'Created Plans & Exemption Requests:',
    ADD_PLAN: 'Add Plan / Exemption +',
    BACK: 'Back',
    VIEW: 'View',
    EDIT: 'Edit',
    EXIT_PLAN_DETAILS: 'Plan Details',
    PRODUCTS_IN_PLAN: 'Products in this Plan:',
    NO_PRODUCTS_SELECTED: 'No products selected.',
    SELECT_PRODUCTS_WARNING: 'You must select at least one product',
    SELECT_PRODUCTS_MESSAGE: 'Please select at least one impacted product to fill an exit plan.',
    SELECT_PRODUCTS_FOR_PLAN: 'Select Products for this Plan',
    SUPPORT_REQUEST: 'Support Request',
    EXIT_DATE: 'Stop Production Date',
    REPLACEMENT_PLAN: 'Replacement Plan',
    ADDITIONAL_COMMENTS: 'Additional Comments',
    END_OF_PRODUCTION_DATE: 'End of Production Date',
    END_OF_IMPORTATION_DATE: 'End of Importation Date',
    LIQUIDATION_PLAN: 'Liquidation Plan',
    NO_ADDITIONAL_INFO: 'No Additional Info available',
    NA: 'N/A'
};

// Default states
export const DEFAULT_SUPPORT_STATE = {
    needsSupport: false,
    marketingSupport: false,
    supplyChainSupport: false,
    selectedMarketingMember: null,
    selectedSupplyChainMember: null
};

// Restriction types
export const RESTRICTION_TYPES = {
    BANNED: 'BANNED',
    RESTRICTED: 'RESTRICTED',
    LABELING_REQUIREMENTS: 'LABELING_REQUIREMENTS',
    RESTRICTIONS_AND_LABELING: 'RESTRICTIONS_AND_LABELING',
    RESTRICTED_AND_SDS: 'RESTRICTED_AND_SDS'
};

// User roles
export const USER_ROLES = {
    MARKETING: 'MARKETING',
    SUPPLY_CHAIN: 'SUPPLY CHAIN'
};